export type LibrarySearchTab =
  | 'category'
  | 'head'
  | 'subHead'
  | 'subCategory'
  | 'address'
  | 'terms'
  | 'accountingCode'
  | 'subAccounting'

export const LIBRARY_SEARCH_PLACEHOLDERS: Record<LibrarySearchTab, string> = {
  category: 'Search categories...',
  head: 'Search heads...',
  subHead: 'Search sub heads...',
  subCategory: 'Search sub categories...',
  address: 'Search addresses...',
  terms: 'Search terms & conditions...',
  accountingCode: 'Search accounting codes...',
  subAccounting: 'Search sub accounting codes...',
}

export function normalizeLibrarySearchTerm(value: string | null | undefined): string {
  return (value ?? '').trim().toLowerCase()
}

export function matchesLibrarySearch(values: Array<string | null | undefined>, term: string): boolean {
  const normalized = normalizeLibrarySearchTerm(term)
  if (!normalized) return true
  return values.some((value) => normalizeLibrarySearchTerm(value).includes(normalized))
}
